import { compact, flattenDeep } from './lodash';

// navigation svg imports
import dashboard from '../assets/navigation/dashboard.svg';
import activities from '../assets/navigation/activities.svg';
import report from '../assets/navigation/report.svg';
import library from '../assets/navigation/library.svg';
import account from '../assets/navigation/account.svg';
import tuneSettings from '../assets/navigation/tune-vertical.svg';
import settings from '../assets/navigation/settings.svg';
import users from '../assets/navigation/users.svg';
import features from '../assets/navigation/features.svg';
import logs from '../assets/navigation/log-files.svg';
// import notification from '../assets/navigation/notification.svg';

// core
export const APP_NAME = 'Takso';
export const BASE_URL =
  import.meta.env.REACT_APP_BASE_URL || 'http://localhost:10010/api';

// stage API is gated by Basic Auth (no IP allowlist) - only set on the
// stage build via Amplify environment variables
export const STAGE_BASIC_AUTH_USER =
  import.meta.env.REACT_APP_STAGE_BASIC_AUTH_USER || '';
export const STAGE_BASIC_AUTH_PASSWORD =
  import.meta.env.REACT_APP_STAGE_BASIC_AUTH_PASSWORD || '';

export const LIMIT = 10;
export const DASHBOARD_LIMIT = 5;

// sidebar routes
export const ROUTES = (t) => {
  return {
    userRoutes: [
      {
        id: 'dash-panel',
        title: t('common.dashboard'),
        icon: 'tachometer alternate',
        image: dashboard,
        route: '/dashboard',
        subRoutes: ['/dashboard'],
        resize: true,
        permission: [
          'admin',
          'organisationAdmin',
          'individualAdmin',
          'user',
          'guest',
        ],
        features: 'dashboard',
      },
      {
        id: 'activity-panel',
        title: t('common.activities'),
        icon: 'calendar alternate outline',
        image: activities,
        route: '/activities',
        subRoutes: [
          '/activities/:id/:type',
          '/activities/:id',
          '/activity/:id/preview',
          '/activity/:id/participants',
        ],
        permission: [
          'admin',
          'organisationAdmin',
          'individualAdmin',
          'user',
          'guest',
        ],
        features: 'activities',
      },
      {
        id: 'report-panel',
        title: t('constant.routes.reports'),
        icon: 'chart bar',
        image: report,
        route: '/reports/activities',
        subRoutes: ['/reports/:type'],
        permission: ['admin', 'organisationAdmin', 'individualAdmin', 'user'],
        features: 'report',
      },
      {
        id: 'all-activities-panel',
        title: t('constant.routes.library'),
        icon: 'calendar check outline',
        image: library,
        route: '/library',
        subRoutes: ['/library/:id/preview'],
        permission: ['admin', 'organisationAdmin', 'user'],
        features: 'library',
      },
      {
        id: 'organisation-panel',
        title: t('common.organisation'),
        icon: 'building outline',
        image: account,
        route: '/organisation',
        subRoutes: [
          '/organisation/:type',
          '/organisation/activity/search',
          '/organisation/activity/by-user',
        ],
        permission: ['admin', 'organisationAdmin'],
        features: 'account',
      },
      {
        id: 'account-panel',
        title: t('common.account'),
        icon: 'building outline',
        image: account,
        route: '/account',
        subRoutes: ['/account/:type'],
        permission: ['individualAdmin'],
        features: 'account',
      },
    ],
    adminRoutes: compact([
      {
        id: 'activity-settings-panel',
        title: t('constant.routes.activity_settings'),
        icon: 'settings',
        image: tuneSettings,
        route: '/admin/activity-settings',
        subRoutes: ['/admin/activity-settings/:type'],
        permission: ['admin'],
      },
      {
        id: 'activities-panel',
        title: t('constant.routes.activities'),
        icon: 'calendar alternate outline',
        image: activities,
        route: '/admin/activities',
        subRoutes: [
          '/admin/activities/:id/:type',
          '/admin/activities/:id',
          '/admin/activity/:id/preview',
          '/admin/activity/:id/participants',
        ],
        permission: ['admin'],
      },
      {
        id: 'system-setting-panel',
        title: t('constant.routes.system_settings'),
        icon: 'setting',
        image: settings,
        route: '/admin/system-settings',
        subRoutes: ['/admin/system-settings/:type'],
        permission: ['admin'],
      },
      {
        id: 'system-report-panel',
        title: t('constant.routes.system_reports'),
        icon: 'chart bar',
        image: report,
        route: '/admin/system-reports',
        subRoutes: ['/admin/system-reports/:type'],
        permission: ['admin'],
      },
      {
        id: 'user-organisation-panel',
        title: t('constant.routes.accounts_users'),
        icon: 'group',
        image: users,
        route: '/admin/accounts',
        subRoutes: ['/admin/accounts/:type'],
        permission: ['admin'],
      },
      {
        id: 'feature-panel',
        title: t('common.features'),
        icon: 'object group outline',
        image: features,
        route: '/admin/system-features',
        subRoutes: ['/admin/system-features/:type'],
        permission: ['admin'],
      },
      {
        id: 'logs-panel',
        title: 'Logs',
        title: t('constant.routes.logs'),
        image: logs,
        route: '/admin/logs',
        subRoutes: ['/admin/logs/:type'],
        permission: ['admin'],
      },
      {
        id: 'audit-panel',
        title: t('constant.routes.data_audit'),
        icon: 'search',
        image: logs,
        route: '/admin/audit',
        subRoutes: [],
        permission: ['admin'],
      },
      {
        id: 'report-builder-panel',
        title: t('constant.routes.report_builder'),
        icon: 'chart bar',
        image: report,
        route: '/admin/report-builder',
        subRoutes: [],
        permission: ['admin'],
      },
    ]),
  };
};

// All system routes
export const ALL_ROUTES = (t) => [
  ...ROUTES(t).userRoutes,
  ...ROUTES(t).adminRoutes,
  {
    id: 'preview-survey',
    title: t('constant.routes.preview_survey'),
    route: '/preview-survey',
    icon: 'ban',
    subRoutes: ['/preview-survey/:surveyId'],
    permission: [
      'admin',
      'organisationAdmin',
      'individualAdmin',
      'user',
      'guest',
    ],
  },
  {
    id: 'user-profile',
    title: t('constant.routes.user_profile'),
    icon: 'ban',
    route: '/user-profile',
    subRoutes: [],
    permission: [
      'admin',
      'organisationAdmin',
      'individualAdmin',
      'user',
      'guest',
    ],
  },
  {
    id: 'user-help',
    title: t('constant.routes.user_help'),
    icon: 'ban',
    route: '/help',
    subRoutes: [],
    permission: [
      'admin',
      'organisationAdmin',
      'individualAdmin',
      'user',
      'guest',
    ],
  },
];

// Account Organisation type only routes
export const ORG_ONLY_ROUTES = ['all-activities-panel', 'organisation-panel'];

// Stable, language-independent identity for each activity tab. Use these to
// drive behaviour (never the translated tab title). Values match the `route`
// strings in ACTIVITY_TABS / PARENT_ACTIVITY_TABS below.
export const ACTIVITY_TAB_KEYS = {
  GOAL: 'goal',
  OBJECTIVE: 'objective',
  EVIDENCE: 'evidence',
  THEORY_OF_CHANGE: 'theory-of-change',
  ACTIVITY_PLAN: 'activity-plan',
  EVALUATION: 'evaluation',
  DOCUMENTATION: 'documentation',
  REPORT: 'report',
  // Green Light is not currently a standalone tab (it renders inside Evaluation),
  // but keep the key so the container's Next-button logic still recognises it if
  // the tab is ever reinstated.
  GREEN_LIGHT: 'green-light',
  ERROR: 'error',
};

// activity routes
export const ACTIVITY_TABS = (t) => [
  {
    id: 0,
    title: t('common.goal').toUpperCase(),
    route: 'goal',
  },
  {
    id: 1,
    title: t('common.objective').toUpperCase(),
    route: 'objective',
  },
  {
    id: 2,
    title: t('common.evidence').toUpperCase(),
    route: 'evidence',
  },
  {
    id: 3,
    title: t('common.theory_of_change').toUpperCase(),
    route: 'theory-of-change',
  },
  {
    id: 4,
    title: t('common.activity_plan').toUpperCase(),
    route: 'activity-plan',
  },
  {
    id: 5,
    title: t('common.evaluation').toUpperCase(),
    route: 'evaluation',
  },
  {
    id: 6,
    title: t('common.documentation').toUpperCase(),
    route: 'documentation',
  },
  {
    id: 7,
    title: t('common.report').toUpperCase(),
    route: 'report',
  },
];

export const PARENT_ACTIVITY_TABS = (t) => [
  {
    id: 0,
    title: t('common.goal').toUpperCase(),
    route: 'goal',
  },
  {
    id: 1,
    title: t('common.objective').toUpperCase(),
    route: 'objective',
  },
  {
    id: 2,
    title: t('common.evidence').toUpperCase(),
    route: 'evidence',
  },
  {
    id: 3,
    title: t('common.theory_of_change').toUpperCase(),
    route: 'theory-of-change',
  },
  {
    id: 4,
    title: t('common.activity_plan').toUpperCase(),
    route: 'activity-plan',
  },
  {
    id: 5,
    title: t('common.evaluation').toUpperCase(),
    route: 'evaluation',
  },
  {
    id: 6,
    title: t('common.documentation').toUpperCase(),
    route: 'documentation',
  },
  {
    id: 7,
    title: t('common.report').toUpperCase(),
    route: 'report',
  },
];

// admin tab routes
export const ADMIN_TABS = (t) => [
  {
    id: 0,
    title: t('common.outcomes'),
    route: 'outcomes',
  },
  {
    id: 1,
    title: t('constant.admin_tabs.evaluation_methods'),
    route: 'evaluation-methods',
  },
  {
    id: 2,
    title: t('constant.admin_tabs.evaluation_qsts'),
    route: 'evaluation-qsts',
  },
  {
    id: 3,
    title: t('constant.admin_tabs.output_formatters'),
    route: 'output-formatters',
  },
  {
    id: 4,
    title: t('common.activity_types'),
    route: 'activity-types',
  },
];
export const ADMIN_LOGS = [
  {
    id: 0,
    title: 'System Logs',
    route: 'system',
  },
  {
    id: 1,
    title: 'Email Logs',
    route: 'email',
  },
];
export const ADMIN_FEATURES = (t) => [
  {
    id: 0,
    title: t('common.features'),
    route: 'features',
  },
  {
    id: 1,
    title: t('common.permission_groups'),
    route: 'permission-groups',
  },
];

export const ADMIN_SYSTEM_SETUP = (t) => [
  {
    id: 0,
    title: t('common.industry_sector_types'),
    route: 'industry-sector-types',
  },
  {
    id: 1,
    title: t('common.venue_types'),
    route: 'venue-types',
  },
  {
    id: 2,
    title: t('common.help'),
    route: 'systemlog-help',
  },
  {
    id: 3,
    title: t('constant.admin_setup.data_export'),
    route: 'data-export',
  },
];

export const ADMIN_USER = (t) => [
  {
    id: 0,
    title: t('common.organisation'),
    route: 'organisation',
  },
  {
    id: 1,
    title: t('common.users'),
    route: 'users',
  },
  {
    id: 2,
    title: t('common.communication'),
    route: 'communication',
  },
];

export const RESTRICTION_TYPES = [
  'project.edit.greenLight',
  'project.edit.report',
];

export const permissionTypes = (t) => [
  {
    id: 1,
    title: t('common.goal'),
    value: 'Goal',
    state: 'project.edit.start',
  },
  {
    id: 2,
    title: t('common.objective'),
    value: 'Objective',
    state: 'project.edit.objective',
  },
  {
    id: 3,
    title: t('common.evidence'),
    value: 'Evidence',
    state: 'project.edit.evidence',
  },
  {
    id: 4,
    title: t('common.theory_of_change'),
    value: 'TheoryOfChange',
    state: 'project.edit.theoryOfChange',
  },
  {
    id: 5,
    title: t('common.activity_plan'),
    value: 'ActivityPlan',
    state: 'project.edit.activityPlan',
  },
  {
    id: 6,
    title: t('common.evaluation'),
    value: 'Evaluation',
    state: 'project.edit.evaluationPlan',
  },
  {
    id: 7,
    title: t('common.green_light'),
    value: 'GreenLight',
    state: 'project.edit.greenLight',
    documentor: true,
  },
  {
    id: 8,
    title: t('common.documentation'),
    value: 'Documentation',
    state: 'project.edit.documentation',
    documentor: true,
  },
  {
    id: 9,
    title: t('common.report'),
    value: 'Report',
    state: 'project.edit.report',
    documentor: true,
    reportOnly: true,
  },
  {
    id: 10,
    title: t('common.notes'),
    value: 'Notes',
    state: 'project.edit.notes',
  },
];

export const ACTIVITIES_ROUTE = ['/activities/:id/:type', '/activities/:id'];

export const REPORT_ROUTE = [
  '/reports',
  '/reports/:type',
  '/reports/activities',
  '/reports/outcome-summary',
  'reports/headline-data',
  'reports/organisation-summary',
];

export const INFO_ROUTES = [
  '/dashboard',
  '/activities',
  '/library',
  '/user-profile',
  '/settings',
  '/organisation',
  '/organisation/:type',
  '/activity/:id/preview',
  '/activities/:id/:type',
  '/activity/:id/participants',
  '/admin/activity-settings',
  '/admin/activity-settings/:type',
  '/system-features',
  '/system-features/:type',
  '/system-logs',
  '/system-settings',
  '/system-settings/:type',
  '/user-accounts',
  '/user-accounts/:type',
  '/activities/:id',
  '/reports',
  '/reports/activities',
  '/reports/:type',
  '/account',
  '/account/:type',
];

export const CompletionProgress = [
  {
    section: 'Goal',
  },
  {
    section: 'Objective',
  },
  {
    section: 'Evidence',
  },
  {
    section: 'Theory of Change',
  },
  {
    section: 'Activity Plan',
  },
  {
    section: 'Evaluation',
  },
  {
    section: 'Documentation',
  },
  {
    section: 'Report',
  },
];

export const CompletionProgressGrant = [
  {
    section: 'Goal',
  },
  {
    section: 'Objective',
  },
  {
    section: 'Evidence',
  },
  {
    section: 'Theory of Change',
  },
  {
    section: 'Activity Plan',
  },
  {
    section: 'Evaluation',
  },
  {
    section: 'Documentation',
  },
  {
    section: 'Report',
  },
];

export const GRANTEE_CSV_TEMPLATE = [
  { label: 'GrantID', key: 'grantId' },
  { label: 'SectorType', key: 'sectorType' },
  { label: 'FirstName', key: 'firstName' },
  { label: 'Surname', key: 'surname' },
  { label: 'Email', key: 'email' },
  { label: 'Phone', key: 'phone' },
  { label: 'EntityName', key: 'entityName' },
  { label: 'ABN', key: 'abn' },
  { label: 'Address1', key: 'address1' },
  { label: 'Address2', key: 'address2' },
  { label: 'Suburb', key: 'suburb' },
  { label: 'State', key: 'state' },
  { label: 'Postcode', key: 'postcode' },
  { label: 'PAddress1', key: 'pAddress1' },
  { label: 'PAddress2', key: 'pAddress2' },
  { label: 'PCitySuburb', key: 'pCitySuburb' },
  { label: 'PState', key: 'pState' },
  { label: 'PPostcode', key: 'pPostcode' },
  { label: 'ActivityName', key: 'activityName' },
  { label: 'ActivityType', key: 'activityType' },
  { label: 'Objective1', key: 'objective1' },
  { label: 'Knowing1', key: 'knowing1' },
  { label: 'WeWill1', key: 'weWill1' },
  { label: 'Objective2', key: 'objective2' },
  { label: 'Knowing2', key: 'knowing2' },
  { label: 'WeWill2', key: 'weWill2' },
  { label: 'ActivitySummary', key: 'activitySummary' },
  { label: 'ProjectedGrantAmount', key: 'projectedGrantAmount' },
  { label: 'ProjectedGrossExpenditure', key: 'projectedGrossExpenditure' },
  { label: 'ActivityStartDate', key: 'activityStartDate' },
  { label: 'ActivityEndDate', key: 'activityEndDate' },
  { label: 'ProjectedIncome', key: 'projectedIncome' },
  { label: 'Evidence1', key: 'evidence1' },
  { label: 'Evidence2', key: 'evidence2' },
  { label: 'Evidence3', key: 'evidence3' },
];

export const ORGANISATION_CORE_DATA = (t) => ({
  annualReport: {},
  coreData: {
    inputs: [
      {
        input:
          t?.('constant.organisation_core_data.capital_assets_buildings') ??
          'Capital assets: buildings/facilities for cultural use (or % use',
        data: { type: 'currency', value: 0 },
        dataToCollect:
          t?.(
            'constant.organisation_core_data.data_to_collect_dollar_capital'
          ) ?? 'Dollar capital value (replacement value)',
      },
      {
        input:
          t?.('constant.organisation_core_data.capital_assets_collections') ??
          'Capital assets: cultural collections',
        data: { type: 'currency', value: 0 },
        dataToCollect:
          t?.(
            'constant.organisation_core_data.data_to_collect_insured_value'
          ) ?? 'Dollar capital value (replacement value, insured valued)',
      },
      {
        input:
          t?.('constant.organisation_core_data.capital_assets_other_sites') ??
          'Capital assets: other sites of cultural significance',
        data: { type: 'currency', value: 0 },
        dataToCollect:
          t?.('constant.organisation_core_data.data_to_collect_dollar_value') ??
          'Dollar capital value',
      },
      {
        input:
          t?.(
            'constant.organisation_core_data.financial_resources_buildings'
          ) ??
          'Financial Resources: Buildings leased for cultural activities (or % use)',
        data: { type: 'currency', value: 0 },
        dataToCollect:
          t?.(
            'constant.organisation_core_data.data_to_collect_projected_expenditure'
          ) ?? 'Projected total expenditure over the year',
      },
      {
        input:
          t?.(
            'constant.organisation_core_data.financial_resources_recurrent'
          ) ??
          'Financial Resources: Recurrent expenditure (allocated to all cultural activities)',
        data: { type: 'currency', value: 0 },
        dataToCollect:
          t?.(
            'constant.organisation_core_data.data_to_collect_projected_expenditure'
          ) ?? 'Projected total expenditure over the year',
      },
    ],
  },
});

export const ageOptions = [
  '0-4',
  '5-9',
  '10-14',
  '15-19',
  '20-24',
  '25-29',
  '30-34',
  '35-39',
  '40-44',
  '45-49',
  '50-54',
  '55-59',
  '60-64',
  '65-69',
  '70-74',
  '75-79',
  '80+',
];

export const getSinglePostTypes = (t) => [
  {
    value: 'SINGLE',
    label: t('chart_types.single_results'),
  },
];

export const getMultiplePostTypes = (t) => [
  {
    value: 'AGGREGATE',
    label: t('chart_types.aggregate_results'),
  },
  {
    value: 'SEPERATE',
    label: t('chart_types.separated_results'),
  },
];

export const getSeparatePostType = (t) => [
  {
    value: 'SEPERATE',
    label: t('chart_types.separated_results'),
  },
];

export const getInterceptSinglePostTypes = (t) => [
  {
    value: 'INTERCEPT_SINGLE',
    label: t('chart_types.single_results'),
  },
];

export const getInterceptMultiplePostTypes = (t) => [
  {
    value: 'INTERCEPT_AGGREGATE',
    label: t('chart_types.aggregate_results'),
  },
  {
    value: 'INTERCEPT_SEPERATE',
    label: t('chart_types.separated_results'),
  },
];

export const getInterceptSeparatePostTypes = (t) => [
  {
    value: 'INTERCEPT_SEPERATE',
    label: t('chart_types.separated_results'),
  },
];

export const getSinglePrepostTypes = (t) => [
  {
    value: 'SINGLE_TREND',
    label: t('chart_types.trend_rate_of_change'),
  },
  {
    value: 'SINGLE_INDIVIDUAL',
    label: t('chart_types.individual_rate_of_change'),
  },
];

export const getSingleMultiplePostTypes = (t) => [
  {
    value: 'INTERCEPT_AGGREGATE',
    label: t('chart_types.aggregate_results'),
  },
  {
    value: 'INTERCEPT_SEPERATE',
    label: t('chart_types.separated_results'),
  },
];

export const getMultiplePrepostTypes = (t) => [
  {
    value: 'TREND',
    label: t('chart_types.aggregate_trend_rate_of_change'),
  },
  {
    value: 'INDIVIDUAL',
    label: t('chart_types.aggregate_individual_rate_of_change'),
  },
];

export const getMultipleIndividualTypes = (t) => [
  {
    value: 'INDIVIDUAL',
    label: t('chart_types.aggregate_individual_rate_of_change'),
  },
];

export const getSelfAssessed = (t) => [
  {
    value: 'SELF-ASSESSED-POST',
    label: t('chart_types.separated'),
  },
  {
    value: 'SELF-ASSESSED-PRE',
    label: t('chart_types.self_assessed_rate_of_change'),
  },
];

export const INTERCEPT_CHART_TYPES = [
  'INTERCEPT_SINGLE',
  'INTERCEPT_AGGREGATE',
  'INTERCEPT_SEPERATE',
];

export const SELF_ASSESSED_CHART_TYPES = [
  'SELF-ASSESSED-POST',
  'SELF-ASSESSED-PRE',
];

export const getAllChartTypes = (t) =>
  flattenDeep([
    getSinglePostTypes(t),
    getMultiplePostTypes(t),
    getInterceptSinglePostTypes(t),
    getInterceptMultiplePostTypes(t),
    getSinglePrepostTypes(t),
    getMultiplePrepostTypes(t),
    getSelfAssessed(t),
  ]);

export const SUBSCRIPTIONS = (t) => [
  {
    id: 1,
    includes: [
      t('constant.subscriptions.plan_evaluate'),
      t('constant.subscriptions.duplicate_plans'),
      t('constant.subscriptions.group_activities'),
      t('constant.subscriptions.aggregated_reports'),
      t('constant.subscriptions.access_library'),
    ],
  },
  {
    id: 2,
    includes: [
      t('constant.subscriptions.basic_contract_templates'),
      t('constant.subscriptions.up_to_25_profiles'),
      t('constant.subscriptions.basic_onboarding'),
    ],
  },
  {
    id: 3,
    includes: [
      t('constant.subscriptions.basic_contract_templates'),
      t('constant.subscriptions.up_to_25_profiles'),
      t('constant.subscriptions.basic_onboarding'),
    ],
  },
];

export const INVOICE_STATUS_OPTIONS = (t) => [
  {
    key: 'all',
    text: <b>{t('common.all')}</b>,
    option: t('common.all'),
    value: 'all',
  },
  {
    key: 'paid',
    text: <b>{t('invoice_status.paid')}</b>,
    option: t('invoice_status.paid'),
    value: 'paid',
  },
  {
    key: 'pending',
    text: <b>{t('invoice_status.pending')}</b>,
    option: t('invoice_status.pending'),
    value: 'pending',
  },
  {
    key: 'overdue',
    text: <b>{t('invoice_status.overdue')}</b>,
    option: t('invoice_status.overdue'),
    value: 'overdue',
  },
  {
    key: 'fail',
    text: <b>{t('invoice_status.fail')}</b>,
    option: t('invoice_status.fail'),
    value: 'fail',
  },
  {
    key: 'closed',
    text: <b>{t('invoice_status.closed')}</b>,
    option: t('invoice_status.closed'),
    value: 'closed',
  },
];

// braintree keys
export let DROP_IN_AUTH_KEY =
  import.meta.env.REACT_APP_ENV_VALUE === 'production'
    ? 'production_9qykfnn2_qr37vkvczwv6snbn'
    : 'sandbox_zjgfgwx6_b82nypwxssb6x7gc';

export const KEY_ACTIVITY_DATA_TYPES = [
  'NUMBER_OF_ACTIVITIES_OUTPUT',
  'NUMBER_OF_SESSIONS_OUTPUT',
  'NUMBER_OF_PARTICIPANTS_OUTPUT',
  'NUMBER_OF_NEW_WORKS_OUTPUT',
  'COLLECTION_ACQUISITIONS_OUTPUT',
  'TOTAL_VOLUNTEERS_OUTPUT',
];

export const ABN_LOOKUP_CONFIG = {
  endpoint: 'https://abr.business.gov.au/json/MatchingNames.aspx',
  token: 'd1632a42-1241-482c-95af-e5bede72c4d5',
};

export const ALLOWED_ONBOARDING_TIPS_PATH = [
  '/dashboard',
  '/activities',
  '/activities/:id',
  '/activities/:id/:type',
];

export const OUTCOME_ADDRESS_BAR_COLORS = {
  CULTURAL: '#FFB500',
  SOCIAL: '#FFA28B',
  ECONOMIC: '#7B60A8',
  GOVERNANCE: '#194B00',
  ENVIRONMENTAL: '#007868',
};

// TODO:api-keys - this is crazy hardcoding these keys in the codebase
export const GOOGLE_API_KEY = import.meta.env.PROD
  ? 'AIzaSyDsMgfBM8kNKaYkkvYy87UNcRaKTHtSWD4'
  : 'AIzaSyBhVuenFiFZb35DetyKvqMIFV7lqEtzpKQ';

export const ORGANISATION_REPORT_TYPES = (t) => [
  {
    key: 1,
    text: t('common.activities'),
    value: 'activities',
    disabled: false,
  },
  {
    key: 2,
    text: t('common.outcomes'),
    value: 'outcomes-addressed',
    disabled: false,
  },
  {
    key: 3,
    text: t('constant.organisation_report_types.outcomes_reported'),
    value: 'outcomes-reported',
    disabled: false,
  },
  {
    key: 4,
    text: t('constant.organisation_report_types.inputs_outputs'),
    value: 'input-output-data',
    disabled: false,
  },
  {
    key: 5,
    text: t('constant.organisation_report_types.management_summary'),
    value: 'management-summary',
    disabled: false,
  },
];

export const REPORT_ALL_TIME_START_DATE = '2018-01-01';
export const REPORT_ALL_TIME_LABEL = 'All Time';

export const ALLOWED_DOCUMENTS_TYPES =
  '.txt, .pdf, .doc, .docx, .odt, .ods, .odp, .ppt, .pptx, .xls, .xlsx, .csv';

export const PARTNER_RELATIONSHIP_VALUES = {
  IN_KIND: 'IN_KIND',
  FUNDING: 'FUNDING',
  NETWORK: 'NETWORK',
};
export const PARTNER_RELATIONSHIP = [
  { value: PARTNER_RELATIONSHIP_VALUES.IN_KIND, label: 'In Kind' },
  { value: PARTNER_RELATIONSHIP_VALUES.FUNDING, label: 'Funding' },
  { value: PARTNER_RELATIONSHIP_VALUES.NETWORK, label: 'Network' },
];

export const PARTNER_RELATIONSHIP_TRANSLATION = (t) => {
  if (t) {
    return [
      {
        value: PARTNER_RELATIONSHIP_VALUES.IN_KIND,
        label: t('organisation.contacts.partner_form.in_kind'),
      },
      {
        value: PARTNER_RELATIONSHIP_VALUES.FUNDING,
        label: t('organisation.contacts.partner_form.funding'),
      },
      {
        value: PARTNER_RELATIONSHIP_VALUES.NETWORK,
        label: t('organisation.contacts.partner_form.network'),
      },
    ];
  }
  return [
    { value: PARTNER_RELATIONSHIP_VALUES.IN_KIND, label: 'In Kind' },
    { value: PARTNER_RELATIONSHIP_VALUES.FUNDING, label: 'Funding' },
    { value: PARTNER_RELATIONSHIP_VALUES.NETWORK, label: 'Network' },
  ];
};

export const ORGANISATION_REPORT_LOADING = {
  ACTIVITY_STATS_LOADING: 'orgActivityStatsLoading',
  ACTIVITY_REPORT_LOADING: 'orgActivityReportLoading',
  VENUE_REPORT_LOADING: 'orgVenueReportLoading',
  PARTICIPANT_REPORT_LOADING: 'orgParticipantReportLoading',
  //map
  ORGANISATION_MAP_LOADING: 'orgMapLoading',
  ACTIVITY_VENUE_MAP_LOADING: 'orgActVenuesMapLoading',
  CONTRACTOR_MAP_LOADING: 'orgContractorMapLoading',
  //outcome summary
  OUTCOME_ADDRESS_LOADING: 'orgOutcomeReportLoading',
  //input-output
  INPUT_OUTPUT_SUMMARY_LOADING: 'orgInputOutputLoading',
  //outcome-reported
  OUTCOME_REPORTED_LOADING: 'orgOutcomeReportLoading',
  //management
  MANAGEMENT_SUMMARY_LOADING: 'orgManagementReportLoading',

  //outcome reports
  POST_PRE_REPORT_LOADING: 'orgPostPreReportLoading',
  POST_REPORT_LOADING: 'orgPostReportLoading',
  INDIVIDUAL_RATE_REPORT_LOADING: 'orgIndividualReportLoading',
};

export const PROGRAM_REPORT_LOADING = {
  ACTIVITY_STATS_LOADING: 'programActivityStatsLoading',
  ACTIVITY_REPORT_LOADING: 'programActivityReportLoading',
  VENUE_REPORT_LOADING: 'programVenueReportLoading',
  PARTICIPANT_REPORT_LOADING: 'programParticipantReportLoading',
  //map
  ORGANISATION_MAP_LOADING: 'programOrgMapLoading',
  ACTIVITY_VENUE_MAP_LOADING: 'programVenueMapLoading',
  CONTRACTOR_MAP_LOADING: 'programContractorMapLoading',
  //outcome summary
  OUTCOME_ADDRESS_LOADING: 'programOutcomeLoading',
  //input-output
  INPUT_OUTPUT_SUMMARY_LOADING: 'programInputOutputLoading',
  //outcome-reported
  OUTCOME_REPORTED_LOADING: 'programOutcomeReportLoading',

  POST_PRE_REPORT_LOADING: 'programPostPreReportLoading',
  POST_REPORT_LOADING: 'programPostReportLoading',
  INDIVIDUAL_RATE_REPORT_LOADING: 'programIndividualReportLoading',
};

// TODO:betalaunch
export const isBetaLaunchAdminEmail = (email) =>
  typeof email === 'string' &&
  email.toLowerCase().endsWith('@culturaldevelopment.net.au');

export const LOGIN_ENCRYPTION_KEY = 'G1yino310m9';

export const REPORT_FILTER_OPTIONS = {
  startDate: null,
  endDate: null,
  statuses: [],
  activityTypes: [],
  venues: [],
  participants: [],
  outcome: null,
  outcomes: [],
  method: 'all',
  methods: [],
  goals: [],
  crossReferences: [],
  departments: [],
  sort: null,
  order: 'asc',
  page: 1,
  limit: LIMIT,
  organisationLevel: 'all',
  renderOutcomeChart: false,
  subVenues: [],
  usedDataOnly: false,
  // TAK-2081: Management Summary's own sort, order and "managed by" filter.
  // Kept with the other report filters, so they last until logout or a page
  // refresh (both reset the store) and survive moving around the app.
  msSort: 'date',
  msOrder: 'newest',
  managerId: null,
};

export const MULTI_LEVEL_PROGRAM_PERMISSION_NAME = 'multi_level_program';

export const CREATE_LINKED_MANAGED_BY_OPTIONS = (t = null) => [
  {
    value: 'CURRENT_USER',
    label: t?.('constant.managed_by_options.myself') ?? 'Myself',
  },
  {
    value: 'INTERNAL_USER',
    label: t?.('constant.managed_by_options.internally') ?? 'Internally',
  },
  {
    value: 'EXTERNAL_USER',
    label: t?.('constant.managed_by_options.externally') ?? 'Externally',
  },
];

export const CREATE_LINKED_MANAGED_BY_OPTIONS_FOR_GUEST = (t = null) => [
  {
    value: 'CURRENT_USER',
    label: t?.('constant.managed_by_options.myself') ?? 'Myself',
  },
  {
    value: 'EXTERNAL_USER',
    label: t?.('constant.managed_by_options.externally') ?? 'Externally',
  },
];

export const SIDEBAR_TYPES = ['HELP', 'NOTE', 'FILTER'];

export const EMAIL_VERIFICATION_STATUS = (t = null) => [
  {
    status: 'ACTIVATED',
    header:
      t?.('constant.email_verification.thank_you_activating') ??
      'Thank you for activating your',
    message:
      t?.('constant.email_verification.email_address') ?? 'email address',
    description: '',
  }, // when the email is activated at the first time
  {
    status: 'ALREADY_ACTIVATED',
    header:
      t?.('constant.email_verification.already_activated') ??
      'You have already activated your',
    message:
      t?.('constant.email_verification.email_address') ?? 'email address',
    description: '',
  }, // if the requested user already activated
  {
    status: 'REQUEST_INVALID',
    header: '',
    message:
      t?.('constant.email_verification.link_no_longer_active') ??
      'This link is no longer active',
    description:
      t?.('constant.email_verification.link_broken_description') ??
      'Looks like this invitation link is broken or has already been used',
  }, // to check token is invalid or expired
];

export const EXPORT_DATA_TYPES = (t) => [
  {
    label: t?.('constant.export_data.activity_data') ?? 'Activity data',
    param: 'activity',
  },
  {
    label: t?.('constant.export_data.contractor_data') ?? 'Contractor data',
    param: 'contractor',
  },
  {
    label: t?.('constant.export_data.venue_data') ?? 'Venue data',
    param: 'venue',
  },
  {
    label: t?.('constant.export_data.partner_data') ?? 'Partner data',
    param: 'partner',
  },
  {
    label: t?.('constant.export_data.outcome_data') ?? 'Outcome data',
    param: 'outcome',
  },
  {
    label:
      t?.('constant.export_data.account_user_data') ?? 'Account and user data',
    param: 'accountUser',
  },
  {
    label: t?.('constant.export_data.evaluation_data') ?? 'Evaluation data',
    param: 'evaluation',
  },
];

/**
 * Departments.
 */
export const MAX_DEPT_LEVELS = 5;

/**
 * Activity Permissions.
 */
export const PERM_ACTIVITY_GOAL = 'project.edit.start';
export const PERM_ACTIVITY_OBJECTIVE = 'project.edit.objective';
export const PERM_ACTIVITY_EVIDENCE = 'project.edit.evidence';
export const PERM_ACTIVITY_THEORY_OF_CHANGE = 'project.edit.theoryOfChange';
export const PERM_ACTIVITY_PLAN = 'project.edit.activityPlan';
export const PERM_ACTIVITY_EVALUATION_PLAN = 'project.edit.evaluationPlan';
export const PERM_ACTIVITY_GREEN_LIGHT = 'project.edit.greenLight';
export const PERM_ACTIVITY_DOCUMENTATION = 'project.edit.documentation';
export const PERM_ACTIVITY_REPORT = 'project.edit.report';
export const PERM_ACTIVITY_NOTES = 'project.edit.notes';

// TAK-2080: lets an invited member duplicate the activity. Stored as an extra
// entry at the END of a member's permissions list (the permission tables read
// the page entries by position); `read` is the on/off flag. Not a page, so it
// is not in permissionTypes or ALL_ACTIVITY_PERM_STATES.
export const PERM_ACTIVITY_DUPLICATE = 'project.duplicate';

export const ALL_ACTIVITY_PERM_STATES = [
  PERM_ACTIVITY_GOAL,
  PERM_ACTIVITY_OBJECTIVE,
  PERM_ACTIVITY_EVIDENCE,
  PERM_ACTIVITY_THEORY_OF_CHANGE,
  PERM_ACTIVITY_PLAN,
  PERM_ACTIVITY_EVALUATION_PLAN,
  PERM_ACTIVITY_GREEN_LIGHT,
  PERM_ACTIVITY_DOCUMENTATION,
  PERM_ACTIVITY_REPORT,
  PERM_ACTIVITY_NOTES,
];
